import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './BlogPage.css';
import { motion } from 'framer-motion';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

const BlogPage = () => {
    const [blogData, setBlogData] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        const fetchBlogData = async () => {
            try {
                const response = await api.get(`https://api.ambitionjet.com/api/blogs/${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`, // Send JWT token
                    },
                    credentials: 'include'
                });
                setBlogData(response.data.blog);
            } catch (error) {
                console.error('Error fetching blog data:', error);
            }
        };

        fetchBlogData();
    }, [id]);

    if (!blogData) {
        return <div>Loading...</div>;
      }

            return (         <div className="blog-container">
            <h1 className="blog-title">{blogData.title}</h1>
            <img className="blog-image" src={blogData.imageUrl} alt="Blog" />
            <div
                className="markdown-content"
                dangerouslySetInnerHTML={{ __html: blogData.content }}
            />
        </div> );
};

export default BlogPage;